import { css } from '@emotion/react'
import styles from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const {
  colors: { gray, primary },
} = styles

const S = {
  input: css`
    display: none;

    &:checked + label::before {
      border: 1px solid ${primary};
    }
    &:checked:not(:disabled) + label::after {
      position: absolute;
      top: 50%;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: var(--Radius-Circle);
      background-color: ${primary};
      transform: translate(50%, -50%);
      content: '';
    }

    &:disabled + label {
      cursor: not-allowed;
    }
    &:disabled + label::before {
      border: 1px solid ${gray.$400};
      background-color: ${gray.$200};
    }

    &:hover:not(:disabled) + label::before {
      border-color: var(--Colors-Green-500);
    }
  `,
  label: css`
    position: relative;
    display: flex;
    align-items: center;
    line-height: 22px;
    cursor: pointer;

    &::before {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 12px;
      border: 1px solid ${gray.$500};
      border-radius: var(--Radius-Circle);
      background-color: white;
      content: '';
    }
  `,
}

export default S
